import { styled } from '@mui/material';

export const Content = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}));

export const IconsWrapper = styled('div')(() => ({
  width: '100%',
  height: '200px',
}));

export const IconsRow = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  height: '50px',
  marginBottom: '8px',
}));

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '50px',
  height: '50px',
  borderRadius: '4px',
  cursor: 'pointer',
  backgroundColor: theme.palette.secondary.light,
  ':hover': {
    boxShadow: theme.shadows[1],
  },
}));
